import * as types from '../mutation-types';
import Echo from 'laravel-echo';

window.io = require('socket.io-client');
const host = process.env.SOCKET_URL || window.location.hostname + ':6001';

export default {
    namespaced: true,

    state: {
        socket: null,
        laravelEcho: null,
    },

    mutations: {
        [types.SET_SOCKET](state, socket) {
            state.socket = socket;
        },

        [types.SET_LARAVEL_ECHO](state, laravel_echo) {
            state.laravelEcho = laravel_echo;
        },
    },

    actions: {
        initSocket({ state, commit }) {
            if (state.socket !== null && state.laravelEcho !== null) {
                return;
            }

            window.Echo = new Echo({
                broadcaster: 'socket.io',
                host: host,
                reconnectionAttempts: 5,
            });

            let socket = window.Echo.connector.socket;

            commit(types.SET_LARAVEL_ECHO, window.Echo);
            commit(types.SET_SOCKET, socket);

            // socket.on('connect', () => console.log('connected'));
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/socket.js